import * as React from 'react';

import { __t, applyTranslations } from 'utils/language';

import './mixed-select-dropdown-menu-select-all.scss';

import type { SyntheticEvent } from 'react';

applyTranslations(require('./mixed-select-dropdown-menu-select-all.i18n.json'));

type Props = {
  onItemsToggleAll: () => void
};

const msgKey = 'mixed_select_dropdown_menu_select_all';

class MixedSelectDropdownMenuSelectAll extends React.PureComponent<Props> {
  handleItemsToggleAll = (event: SyntheticEvent<HTMLElement>): void => {
    const { onItemsToggleAll } = this.props;

    // handle the result of `onMouseDown` being used instead of `onClick`
    event.preventDefault();

    onItemsToggleAll();
  };

  render(): React.ReactNode {
    // reason for using `onMouseDown` instead of `onClick`
    // https://stackoverflow.com/a/28963938
    return (
      <div
        className="mixed-select-dropdown-menu-select-all"
        onMouseDown={this.handleItemsToggleAll}
      >
        {__t(`${msgKey}.labels.select_all`)}
      </div>
    );
  }
}

export default MixedSelectDropdownMenuSelectAll;
